/**
 * Why a campaign was paused because a lead could not be sent (PREC-4059). Each reason is a
 * problem only the customer can fix, so it stops the whole campaign rather than failing lead after
 * lead: in the campaign itself, or, for OUT_OF_CREDITS, by adding credits.
 *
 * Shared because both halves key their copy on it: the API's mail (`campaign-pause-copy.ts`) and
 * the web's dashboard issue (`campaignPausedIssueDisplay.ts`). Each holds a
 * `Record<CampaignPauseReason, …>`, so a new reason does not compile until both say what it means.
 */
export enum CampaignPauseReason {
	/** A LinkedIn connection note is longer than the sender's limit once personalised (PREC-3970). */
	INVITE_NOTE_TOO_LONG = "INVITE_NOTE_TOO_LONG",
	/** No active sender is left for the campaign's first step, so no lead can be scheduled (PREC-4036). */
	NO_ACTIVE_SENDERS = "NO_ACTIVE_SENDERS",
	/**
	 * Senders are active, but none on the channel the first step sends on — a LinkedIn invite
	 * first with only mailboxes active, or the reverse (PREC-4314). `detail.channel` names it.
	 */
	NO_SENDER_FOR_FIRST_STEP_CHANNEL = "NO_SENDER_FOR_FIRST_STEP_CHANNEL",
	/**
	 * The balance cannot pay for the email lookup a step needs at send time (PREC-2803). Unlike the
	 * other reasons it is fixed outside the campaign: a credit top-up resumes the campaign on its
	 * own. `detail` carries `creditsAvailable` and `creditsRequired`.
	 */
	OUT_OF_CREDITS = "OUT_OF_CREDITS",
}
